import React from "react";
import { useTranslation } from "react-i18next";
import DeliveryNoteDetailsDocRecords from "./DeliveryNoteDetailsDocRecords";
import {
  docHasGroups,
  docLeaves,
  formatDocCellForDisplay,
  getDocFieldWidget,
} from "./utils";

export default function DeliveryNoteDetailsDocTable({ schema, documentation }) {
  const { t } = useTranslation();
  const columns = schema?.columns || [];
  const rows = documentation?.rows || [];
  const documentColumns = schema?.document_columns || [];
  const documentValues = documentation?.document_values || {};
  const leaves = docLeaves(columns);
  const hasGroups = docHasGroups(columns);
  const rowLabel = schema?.row_label || t("common.line");

  return (
    <>
      {hasGroups && <DeliveryNoteDetailsDocRecords columns={columns} rows={rows} rowLabel={rowLabel} />}

      {columns.length > 0 && !hasGroups && (
        <div className="table-responsive">
          <table className="table table-delivery_note table-hover mb-0">
            <thead>
              <tr>
                <th width={1}>{rowLabel}</th>
                {leaves.map((leaf) => (
                  <th key={leaf.id}>
                    {leaf.title}
                    {leaf["x-unit"] && <small className="text-muted ms-1">({leaf["x-unit"]})</small>}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((row, rowi) => (
                <tr key={`doc-row-${rowi}`}>
                  <td>{rowi + 1}</td>
                  {leaves.map((leaf) => {
                    const isBoolean = getDocFieldWidget(leaf) === "boolean";
                    return (
                      <td key={leaf.id} className={isBoolean ? "text-end" : ""}>
                        {formatDocCellForDisplay(leaf, row[leaf.id])}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {documentColumns.length > 0 && (
        <ul className="list-unstyled mt-2 mb-0 doc-document-fields">
          {documentColumns.map((col) => {
            const value = documentValues[col.id];
            const label = col.description || col.title;
            if (getDocFieldWidget(col) === "boolean") {
              return (
                <li key={col.id} className="d-flex align-items-start gap-2 py-1">
                  <span className="mt-1" aria-hidden="true">
                    {value ? "☑" : "☐"}
                  </span>
                  <span>{label}</span>
                </li>
              );
            }
            return (
              <li key={col.id} className="py-1">
                {col.title && <strong className="me-2">{col.title}:</strong>}
                <span>{formatDocCellForDisplay(col, value)}</span>
                {col.description && <em className="text-muted ms-2">{col.description}</em>}
              </li>
            );
          })}
        </ul>
      )}
    </>
  );
}
